<template>
  <div class="set_catalog_wrap">
    <div class="set_catalog_title">
      <p class="goback" @click="back">
        <img src="../../../../static/images/course/icon-3.png" alt="">
        <span>返回</span>
      </p>
      <h2>设置目录</h2>
      <div class="edit_and_preview">
        <el-button @click="setData(0)">开放章节</el-button>
        <el-button @click="setData(1)">锁定章节</el-button>
      </div>
    </div>
    <div class="set_catalog_main">
      <ul>
        <li>
          <div class="checkbox">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
          </div>
          <div>章节</div>
          <div>章节状态</div>
        </li>
        <el-tree
          v-if="list.length>0"
          :data="list"
          :props="defaultProps"
          node-key="id"
          show-checkbox
          :highlight-current="true"
          @check-change="handleCheckChange"
          ref="tree"
        >
          <div slot-scope="{ node, data }" class="item_div">
            <p class="tree_name">{{node.label}}</p>
            <p class="tree_issuedStatus">
              <span v-if="data.lockStatus==0">开放</span>
              <span v-if="data.lockStatus==1">锁定</span>
            </p>
          </div>
        </el-tree>
      </ul>
      <div v-if="!list.length>0" class="null_box">
        <img src="../../../../static/images/wujieguo.png" />
        <p>暂无数据</p>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../../api/courseApi'
export default {
  data() {
    return {
      courseId: this.$route.query.id,//课程ID
      isIndeterminate: false,//全选、半选状态
      checkAll: false,//是否全选
      defaultProps: {
        children: "children",
        label: "catalogName"
      },
      list: [],//目录树
      dataList: [],//选中的目录
    }
  },
  methods: {
    back(){
      this.$parent.setMenu(false)
    },
    handleCheckAllChange(val) {
      if (this.checkAll) {//全选
        this.$refs.tree.setCheckedNodes(this.list);
      } else {//取消选中
        this.$refs.tree.setCheckedNodes([]);
      }
    },
    getCatalog(){//获取目录
      api.getCourseCatalog(this.courseId).then(rs=>{
        if(rs.code==0){
          this.list = rs.data
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    handleCheckChange() {//目录树选中
      let res = this.$refs.tree.getCheckedNodes();
      let arr = [];
      res.forEach(item => {
        arr.push(item.id);
      });
      this.dataList = arr;
    },
    setData(status) {//设置目录状态
      if (this.dataList.length == 0) {
        this.$messageWarning('请选择要设置的章节')
        return;
      }
      let str = ''
      if(status==0){
        str = '确定开放发布吗？'
      }else{
        str = '确定锁定发布吗？'
      }
      this.$tipsDialog(
        "提示",
        str,
        "",
        "el-icon-warning",
        "rgb(255, 178, 60)"
      ).then(() => {
        this.setCatalogFn(this.dataList, status)
      }).catch(() => {
        console.log("cancel");
      });
    },
    setCatalogFn(arr, flag){
      api.setCatalog({
        "ids": arr,
        "lock": flag
      }).then(rs=>{
        if(rs.code==0){
          this.$messageSuccess('设置成功')
          this.checkAll = false
          this.isIndeterminate = false
          this.getCatalog()
        }else{
          this.$messageError(rs.msg)
        }
      })
    }
  },
  mounted() {
    this.getCatalog()
  },
}
</script>
<style lang="scss" scoped>
  .set_catalog_wrap{
    .set_catalog_title{
      height: 60px;
      border-bottom: 1px solid #DDE0E2;
      display: flex;
      align-items: center;
      position: relative;
      h2{
        color: #333;
        font-size: 16px;
        margin-left: 24px;
        position: relative;
        font-weight: 600;
        &::after{
          content: '';
          position: absolute;
          left: -10px;
          top: 3px;
          width: 4px;
          height: 12px;
          background: #5397F7;
        }
      }
      .goback{
        cursor: pointer;
        font-size: 14px;
        display: flex;
        align-items: center;
        span{
          font-size: 14px;
          font-weight: 400;
        }
        img{
          height: 18px;
          margin: 0 3px;
        }
      }
      .edit_and_preview{
        position: absolute;
        right: 0;
        top: 15px;
        button{
          padding: 0 10px;
          height:32px;
          border:1px solid rgba(83,151,247,1);
          border-radius:4px;
          color:#fff;
          background: #5397F7;
        }
        button:hover{
          opacity: 0.8;
        }
      }
    }
    .set_catalog_main{
      ul {
        margin-top: 10px;
        li {
          display: flex;
          justify-content: space-between;
          line-height: 40px;
          border: 1px solid rgba(226, 226, 226, 1);
          background: rgba(83, 151, 247, 0.1);
          border-radius: 4px 4px 0px 0px;
          font-size: 14px;
          div {
            text-align: center;
            color: rgba(153, 153, 153, 1);
            .el-checkbox {
              width: 150px;
              display: block;
              margin: 0 auto;
            }
            &:nth-child(2){ flex: 1; text-align: left; }
            &:nth-child(3){ width: 200px; }
          }
        }
        /deep/ .el-tree{
          .el-tree-node{
            .el-tree-node__content{
              height: 40px;
              line-height: 40px;
              .el-tree-node__expand-icon{
                margin-left: 46px;
              }
              .el-checkbox{
                width: 80px;
              }
              .item_div{
                display: flex;
                width: 100%;
                .tree_name{
                  flex: 1;
                  font-size: 12px;
                }
                .tree_issuedStatus{
                  width: 200px;
                  text-align: center;
                  span{
                    color: #333;
                    font-size: 12px;
                  }
                }
              }
            }
          }
        }
      }
      .null_box {
        padding-top: 100px;
        height: 100px;
        text-align: center;
        p {
          color: #999999;
        }
        img {
          margin: 0 auto;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/course/setCatalog.vue